/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { Checkbox, FormControl, FormControlLabel, FormLabel, makeStyles, RadioGroup } from '@material-ui/core';
import CustomRadio from 'components/CustomRadio';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ImportStrategy } from './importStrategy';

const useStyles = makeStyles({
  root: {
    display: 'block',
  },
  checkbox: {
    backgroundColor: '#D1E3FA',
    marginTop: '1rem',
    padding: '0.1rem',
  },
});

export default function ImportStrategyForm(props) {
  const classes = useStyles();
  const { t } = useTranslation();

  const { remainingDuplicates, strategy, applyToAll, onStrategyChange, onApplyToAllChange } = props;
  return (
    <>
      <FormControl classes={{ root: classes.root }}>
        <FormLabel>Select an option:</FormLabel>
        <RadioGroup aria-label={t('strategy.import')} value={strategy} onChange={onStrategyChange}>
          <FormControlLabel value={ImportStrategy.SKIP} control={<CustomRadio />} label={t('contact.skip.duplicate')} />
          <FormControlLabel
            value={ImportStrategy.OVERWRITE}
            control={<CustomRadio />}
            label={t('contact.overwrite.existing')}
          />
          <FormControlLabel
            value={ImportStrategy.SAVE_AS_NEW}
            control={<CustomRadio />}
            label={t('contact.duplicate.save')}
          />
        </RadioGroup>
      </FormControl>
      {remainingDuplicates > 1 && (
        <FormControlLabel
          className={classes.checkbox}
          classes={{ root: classes.root }}
          control={<Checkbox checked={applyToAll} onChange={onApplyToAllChange} name="apply to all" />}
          label={t('contact.apply.all.duplicates')}
        />
      )}
    </>
  );
}
